export default __webpack_public_path__ + "static/media/default-brand.d5781050.png";